import { Injectable, OnInit } from '@angular/core';
import { ModalService } from '../modal-factory/modal-factory';
import { LayoutService } from '../layout/layout.service';
import { ObservablesService } from '../../Services/observables/observables';

import { isEmpty, assign } from 'lodash';
@Injectable()
export class ModalHandlerService {
	constructor(
		private observablesService: ObservablesService,
		private layoutService: LayoutService,
		private modalService: ModalService
	) {}

	handleModalresponse(res: Response, action: string) {
		if (res.action == 'modal') {
			// Close modal if data is empty
			if (isEmpty(res.data)) {
				this.modalService.close();
			}

			if (this.modalService.isOpen) {
				const windowClass = !isEmpty(this.layoutService.staticLayout.getValue().data.ui.modal.attributes)
					? this.layoutService.staticLayout.getValue().data.ui.modal.attributes.type
					: '';
				let data = {
					controls: this.layoutService.staticLayout.getValue().data.ui.modal.controls,
					instructions: this.layoutService.staticLayout.getValue().data.instructions,
					windowClass: windowClass,
					attributes: res.data['attributes'],
				};
				if (action == 'SaveInfoWeFoundPopup') {
					this.modalService.close();
					setTimeout(() => {
						const windowClass = !isEmpty(this.layoutService.staticLayout.getValue().data.ui.modal.attributes)
							? this.layoutService.staticLayout.getValue().data.ui.modal.attributes.type
							: '';
						this.modalService.open({
							data: this.layoutService.staticLayout.getValue().data.ui.modal,
							windowClass: windowClass,
						});
					}, 0);
					return;
				}
				this.observablesService.modalUpdated.next(data);
			}

			if (!this.modalService.isOpen) {
				const windowClass = !isEmpty(this.layoutService.staticLayout.getValue().data.ui.modal.attributes)
					? this.layoutService.staticLayout.getValue().data.ui.modal.attributes.type
					: '';
				const submissionLoaderElement = document.getElementById('submission-preloader-popup');
				if (submissionLoaderElement) {
					submissionLoaderElement.style.display = 'none'; // Hides the loader
				}
				this.modalService.open({
					data: this.layoutService.staticLayout.getValue().data.ui.modal,
					windowClass: windowClass,
				});
			} else if (action === 'CloseModal') {
				this.modalService.close();
			}
		} else if (this.modalService.isOpen) {
			this.modalService.close();
		} else {
			this.modalService.close();
		}
	}
}
